import React, { useEffect, useState } from "react";
import "./DboardHeader.css";
import profile_picture from "../../images/profile_picture.svg";
import default_pfp from "../../images/default_pfp.svg";
import down_arrow from "../../images/down_arrow_admin.svg";
import { useNavigate, Link } from "react-router-dom";
import { CommunityOwner, SuperAdmin } from "../../Utils/Constant";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfileData } from "../../Services/Profile/ProfileApi";
import { setHeaderMessage } from "../../Services/DashboardHeader/uiSlice";
import { capitalizeFirstLetter } from "../../Utils/LetterCase";


function DashboardHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
  const firstName = localStorage.getItem("user_first_name");
  const lastName = localStorage.getItem("user_last_name");
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState({});
  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_type");
    localStorage.removeItem("user_first_name");
    localStorage.removeItem("user_last_name");
    localStorage.removeItem("refresh-token");
    dispatch(setHeaderMessage("Community Management"));
  };
  const { data } = useSelector((state) => state.fetchProfileData);
  const headerMessage = useSelector((state) => state.ui.headerMessage);

  // useEffect(() => {
  //   dispatch(fetchProfileData(userId)).finally(() => setLoading(false));
  // }, [dispatch]);

  useEffect(() => {
    if (data) {
      setProfile(data?.data);
    }
  }, [data]);

  return (
    <>
      <div className="header-main">
        <div className="header-inner-main d-flex justify-content-between align-items-center">
          {/* <div className="dashboard-title">Community Management</div> */}
          <div className="dashboard-title">{headerMessage}</div>
          <div className="">
            <div class="dropdown">
              <div
                class="dropdown-toggle d-flex align-items-center gap-3 admin-profile-dropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-picture-admin">
                  <img
                    src={profile?.image || default_pfp}
                    alt="Profile-picture"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = default_pfp; // Fallback image
                    }}
                  />
                </div>

                <div className="admin-name-div">
                  {capitalizeFirstLetter(firstName) + " " + capitalizeFirstLetter(lastName)}
                  <span>
                    {userType === CommunityOwner
                      ? "Admin"
                      : userType === SuperAdmin
                        ? "Super Admin"
                        : "Homeowner"}
                  </span>
                </div>
                <div className="down-arrow-block">
                  <img src={down_arrow} alt="down-arrow"></img>
                </div>
              </div>
              <ul class="dropdown-menu">
                <li>
                  <Link
                    to={
                      userType === CommunityOwner
                        ? "/admin/admin-profile"
                        : userType === SuperAdmin
                          ? "/super-admin/super-admin-profile"
                          : "/home-owner-admin/homeowner-profile"
                    }
                    onClick={() => dispatch(setHeaderMessage("Profile"))}
                    class="dropdown-item"
                  >
                    View Profile
                  </Link>
                </li>
                {/* <li>
                  <a class="dropdown-item" href="#">
                    Another action
                  </a>
                </li> */}
                <li>
                  <Link
                    class="dropdown-item"
                    onClick={handleLogout}
                    to="/"
                  >
                    Logout
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardHeader;
